<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-100">
      <div class="text-center" style="margin-bottom: 48px;">
        <h3>
          <img
            src="../assets/images/pinkpanther.png"
            width="40px"
            alt="pinkpanther"
          />
          | Clouseau 4.0
        </h3>
        <p>Club Management System</p>
        <!--
        <p>
          Log in to see how you can save more than 300 hours of work with an integrated Laravel API backend and ready-made CRUDs for managing: #users, #roles, #items, #categories, #tags.
        </p>
        -->
      </div>
      <!--
      <div class="text-center" style="margin-bottom: 32px;">
        <h5><strong>You can log in with 3 user types:</strong></h5>
        <div>Username <b>admin@material.com</b> Password <b>secret</b></div>
        <div>Username <b>creator@material.com</b> Password <b>secret</b></div>
        <div>Username <b>member@material.com</b> Password <b>secret</b></div>
      </div>
      -->
    </div>

    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="green" v-if="apiValidationErrors.tfa_secret">
        <h4 slot="title" class="title">Code eingeben</h4>
        <template slot="description"
          >Wir haben eine SMS an {{ mobileExtract }} gesendet, bitte diesen Code
          eingeben, um sich anzumelden</template
        >
        <md-field class="form-group md-invalid" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>PIN-Code</label>
          <md-input
            autofocus
            ref="tfa_secret"
            v-model="tfa_secret"
            type="password"
            @keypress.enter="login"
          />
          <validation-error :errors="apiValidationErrors.tfa_secret" />
        </md-field>
        <md-button
          :disabled="loggingIn"
          slot="footer"
          @click="login"
          class="md-simple md-success md-lg"
        >
          Los geht´s
        </md-button>
      </login-card>
      <login-card header-color="green" v-else>
        <h4 slot="title" class="title">Anmeldung</h4>
        <md-field
          class="form-group md-invalid"
          slot="inputs"
          style="margin-bottom: 28px"
        >
          <md-icon>email</md-icon>
          <label>E-Mail...</label>
          <md-input
            autofocus
            v-model="email"
            type="email"
            @keypress.enter="login"
          />
          <validation-error :errors="apiValidationErrors.email" />
        </md-field>
        <md-field class="form-group md-invalid" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Passwort...</label>
          <md-input
            v-model="password"
            type="password"
            @keypress.enter="login"
          />
          <validation-error :errors="apiValidationErrors.password" />
        </md-field>
        <md-button
          :disabled="loggingIn"
          slot="footer"
          @click="login"
          class="md-simple md-success md-lg"
        >
          Los geht´s
        </md-button>
      </login-card>
    </div>
  </div>
</template>

<script>
import { LoginCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    LoginCard,
    ValidationError
  },
  mixins: [formMixin],
  mounted() {
    if (this.$route.query.verifizierung) {
      this.verifyEmail(this.$route.query.verifizierung);
    }
  },
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated();
    }
  },
  data: () => ({
    loggingIn: false,
    email: "",
    tfa_secret: "",
    password: "",
    mobile_extract: ""
  }),
  methods: {
    async verifyEmail(url) {
      this.axios
        .get(url)
        .then(() => {
          this.$notify({
            message:
              "E-Mail-Adresse wurde verifiziert, Sie können sich jetzt anmelden",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
            timeout: 12000
          });
        })
        .catch(() => {
          this.$notify({
            message: "E-Mail-Adresse konnte nicht verifiziert werden",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
            timeout: 12000
          });
        });
    },
    async login() {
      this.loggingIn = true;
      const user = {
        data: {
          type: "token",
          attributes: {
            email: this.email,
            password: this.password,
            tfa_secret: this.tfa_secret
          }
        }
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json"
        }
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
      } catch (e) {
        if (e.response) {
          this.setApiValidation(e.response.data.errors);
          const tfaError = e.response.data.errors.find(
            err => err.meta && err.meta.mobile_extract
          );
          if (e.response && e.response.status === 403) {
            this.$store.dispatch(
              "alerts/error",
              "E-Mail-Adresse nicht bestätigt"
            );
          } else if (tfaError) {
            this.mobileExtract = tfaError.meta.mobile_extract;
            this.$nextTick(() => {
              this.$refs.tfa_secret.$el.focus();
            });
          } else {
            this.$store.dispatch("alerts/error", "Anmeldung fehlgeschlagen");
          }
        }
        this.loggingIn = false;
      }
    }
  }
};
</script>
